import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1.5),
    },
    promptField: {
      overflow: 'auto',
    },
    editable: {
      ...theme.typography.paragraph16,
      flex: 1,
      minHeight: '92px !important', //overrides styles of slate in case of placeholder
    },
    actions: {},
  }),
  { name: 'NewProjectPromptWidget' }
);
